import { PromoPartnerFamily } from "../entities/promo-partner-family.entity";
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';


export class PromoPartnerFamilyRequest extends BaseRequest {

    promoPartnerFamily : PromoPartnerFamily;
}
